import * as Yup from "yup";

export enum TeamFormHeader {
  add = "Add Team",
  edit = "Edit Team",
}

export const StatusOptions = ["Active", "Inactive"] as const;

export const TeamFormSchema = Yup.object({
  status: Yup.string()
    .oneOf([...StatusOptions])
    .defined("Required"),
  team: Yup.string().required("Required"),
  nickName: Yup.string().required("Required"),
  lead: Yup.string(),
});

export type TeamFormType = Yup.TypeOf<typeof TeamFormSchema>;
